export class TraceabilityContextConstants{
    public static readonly ALL: string = "ALL";
    public static readonly OTHER: string = "OTHER";
    public static readonly FISHING: string = "FISHING";
}